import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { matchPasswords } from 'app/validations/match-passwords.validator';
import { passwordStrengthValidator } from 'app/validations/password-strength.validator';
import { ChangeTokenPassword } from 'app/models/change-token-password';
import { Log } from 'app/core/logging/log';
import { LanguageService } from 'app/services/language/language.service';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ForgotPasswordComponent implements OnInit {
    
    @Output() goTo = new EventEmitter<any>();
    @Output() callbackFunction = new EventEmitter<any>();
    focus;
    focus1;
    mode: string = 'reset';
    token: string;
    title: string;
    form: FormGroup;
    sent: boolean = false;
    passwordStrength = 0;

    constructor(
        private restService: RestService,
        private appService: AppService,
        private router: Router,
        private language: LanguageService,
        private route: ActivatedRoute) { }

    ngOnInit() {
        
        this.title = this.appService.getTraduccion('reset_password');
        let parameters:ParamMap = this.route.snapshot.queryParamMap;
        if(parameters.has('token')){
            this.title = this.appService.getTraduccion('change_password');
            this.mode = 'change';
            this.token = parameters.get('token');
        }

        this.initForm();

        this.form.valueChanges.subscribe((e) => {
            Log.debug("form changed", {e, form: this.form});
       });
    }

    
    initForm(){
        this.form = new FormGroup({
            'email': new FormControl('',[

            ]),
            'langCode': new FormControl(AppService.langSel.name, [
                Validators.required
            ]),
            'newPassword': new FormControl('',[
                
            ]),
            'passwordConfirm': new FormControl('',[

            ])
        },
        {   
            validators: this.passwordValidation.bind(this)
        });

        if(this.mode=='change'){
            this.form = new FormGroup({
                'newPassword': new FormControl('',[
                    Validators.required,
                    passwordStrengthValidator()
                ]),
                'passwordConfirm': new FormControl('',[
                    Validators.required
                ])
            },
            {   
                validators: matchPasswords('newPassword', 'passwordConfirm')
            });
            
            this.form.get('newPassword')?.valueChanges.subscribe(() => {
                const control = this.form.get('password');
                const errors = control?.errors as any;
                this.passwordStrength = errors?.strength ?? 0;
            });

        }else{
            this.form = new FormGroup({
                'email': new FormControl('',[
                    Validators.required,
                    Validators.email
                ])
            });
        }
        
    }

    get email() { return this.form.get('email'); }
    get newPassword() { return this.form.get('newPassword'); }
    get passwordConfirm() { return this.form.get('passwordConfirm'); }

    _goTo(value: string){
        Log.debug("f_goTo", {value});
        this.goTo.emit(value);
    }

    submitForm(){
        this.validateAllFormFields(this.form);
        if (this.form.invalid) {
            Log.debug("Formulario no valido", {form:this.form});
            return;
        }

        if(this.mode == 'reset'){
            this.reset(this.form);
        }else{
            this.change(this.form);
        }
    }

    reset(form: FormGroup){
        let email:string = form.get('email').value;
        this.restService.forgotPassword(email).subscribe(result => {
            if(result){
                this.appService.showSuccessToast(this.appService.getTraduccion('resetPassword.ok'));
                this.form.controls['email'].disable();
                this.sent = true;
            }else{
                this.appService.showDangerToast(this.appService.getTraduccion('resetPassword.ko'));
            }
        });
    }

    change(form: FormGroup){
        let changeTokenPassword:ChangeTokenPassword = {
            token: this.token,
            password: form.get('newPassword').value
        }
        this.restService.resetPassword(changeTokenPassword).subscribe(result => {
            this.appService.showSuccessToast(this.appService.getTraduccion('changePassword.ok'));
            this.router.navigate([this.language.path('signin')]);
        });
    }

    passwordValidation(formGroup: FormGroup) {
        const { value: password } = formGroup.get('newPassword');
        const { value: passwordConfirm } = formGroup.get('passwordConfirm');
        return password === passwordConfirm ? null : { passwordNotMatch: true };
    }
    

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
          const control = formGroup.get(field);
          if (control instanceof FormControl) {
            control.markAsTouched({ onlySelf: true });
          } else if (control instanceof FormGroup) {
            this.validateAllFormFields(control);
          }
        });
    }

}
